var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { i18n, utils as dataUtils } from '@easydata/core';
import { domel } from '@easydata/ui';
import { FacetType } from '../types/facet_type';
import { ResultFacet } from './result_facet';
import { ChartJsWidget } from '../widgets/charts/chart_widget_chartjs';
import { GoogleChartWidget } from '../widgets/charts/chart_widget_google';
import { browserUtils } from '../utils/browser_utils';
var ChartFacet = /** @class */ (function (_super) {
    __extends(ChartFacet, _super);
    function ChartFacet() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.title = i18n.getText('Facets', 'Chart', 'FacetTitle');
        _this.dialogTitle = i18n.getText('Facets', 'Chart', 'DlgTitle');
        return _this;
    }
    ChartFacet.prototype.init = function (slot) {
        _super.prototype.init.call(this, slot);
        if (GoogleChartWidget.hasGoogleCharts()) {
            this.chart = new GoogleChartWidget(this.contentDiv);
        }
        else {
            this.chart = new ChartJsWidget(this.contentDiv);
        }
        var supportedChartTypes = this.container.options
            ? this.container.options.supportedChartTypes
            : null;
        this.chart.init(this.getContext(), {
            legend: {
                show: false
            },
            showOnPaging: true,
            hideSettings: true,
            supportedChartTypes: supportedChartTypes
        });
        //prevent showing chart tab
        domel(this.slot).hide();
    };
    ChartFacet.prototype.destroy = function () {
        if (this.chart) {
            this.chart.destroy();
        }
    };
    ChartFacet.prototype.getType = function () {
        return FacetType.Chart;
    };
    ChartFacet.prototype.renderFormFields = function (form, fieldsContainer) {
        var _this = this;
        _super.prototype.renderFormFields.call(this, form, fieldsContainer);
        var isIE = browserUtils.isIE();
        var horizClass = isIE ? 'kfrm-fields-ie is-horizontal' : 'kfrm-fields is-horizontal';
        // Chart type
        var chartTypeSelector = document.createElement('select');
        chartTypeSelector.id = 'chart_type_selector';
        chartTypeSelector.name = 'chart_type_selector';
        for (var _i = 0, _a = this.chart.getSupportedChartTypes(); _i < _a.length; _i++) {
            var ct = _a[_i];
            var sopt = document.createElement('option');
            sopt.value = ct.toString();
            sopt.text = this.chart.getChartTypeName(ct);
            chartTypeSelector.appendChild(sopt);
        }
        chartTypeSelector.value = this.chart.getCurrentChartType().toString();
        if (!this.settings) {
            this.chart.prepareChartData();
            this.settings = {
                type: this.chart.getCurrentChartType().toString(),
                labelColumn: "" + (this.chart.getLabelColumnIndex() >= 0 ? this.chart.getLabelColumnIndex() : ''),
                dataColumn: "" + (this.chart.getDataColumnIndex() >= 0 ? this.chart.getDataColumnIndex() : ''),
                showLegend: false
            };
        }
        // Label column
        var labelColumnSelector = document.createElement('select');
        labelColumnSelector.name = 'label_column_selector';
        labelColumnSelector.id = 'label_column_selector';
        for (var _b = 0, _c = this.chart.getPotentialLabelColumns(); _b < _c.length; _b++) {
            var col = _c[_b];
            var sopt = document.createElement('option');
            sopt.value = col.idx.toString();
            sopt.text = col.label;
            labelColumnSelector.appendChild(sopt);
        }
        labelColumnSelector.value = this.settings.labelColumn;
        // Data column
        var dataColumnSelector = document.createElement('select');
        dataColumnSelector.id = 'data_column_selector';
        dataColumnSelector.name = 'data_column_selector';
        for (var _d = 0, _e = this.chart.getPotentialDataColumns(); _d < _e.length; _d++) {
            var col = _e[_d];
            var sopt = document.createElement('option');
            sopt.value = col.idx.toString();
            sopt.text = col.label;
            dataColumnSelector.appendChild(sopt);
        }
        dataColumnSelector.value = this.settings.dataColumn.toString();
        var current = fieldsContainer;
        var getCurrent = function () {
            if (isIE) {
                return domel('div', fieldsContainer)
                    .addClass('kfrm-field-ie')
                    .toDOM();
            }
            else {
                return fieldsContainer;
            }
        };
        if (isIE) {
            domel(form)
                .addChildElement(getCurrent());
        }
        else {
            domel(fieldsContainer)
                .addChild('div')
                .addChild('div');
        }
        current = getCurrent();
        domel(current)
            .addChild('label', function (b) { return b
            .attr('for', 'chart_type_selector')
            .text(i18n.getText('Facets', 'Chart', 'ChartTypeSelectorLabel')); })
            .addChild('div', function (b) {
            return b
                .addClass('kfrm-select')
                .addChildElement(chartTypeSelector);
        });
        current = getCurrent();
        domel(current)
            .addChild('label', function (b) { return b
            .attr('for', 'label_column_selector')
            .text(i18n.getText('Facets', 'Chart', 'LabelColumnSelectorLabel')); })
            .addChild('div', function (b) { return b
            .addClass('kfrm-select')
            .addChildElement(labelColumnSelector); });
        current = getCurrent();
        domel(current)
            .addChild('label', function (b) { return b
            .attr('for', 'data_column_selector')
            .text(i18n.getText('Facets', 'Chart', 'DataColumnSelectorLabel')); })
            .addChild('div', function (b) { return b
            .addClass('kfrm-select')
            .addChildElement(dataColumnSelector); });
        current = getCurrent();
        domel(current)
            .addChild('div')
            .addChild('div', function (b) { return b
            .addClass(horizClass)
            .addChild('label', function (b) { return b
            .addClass('checkbox')
            .addChild('input', function (b) {
            b
                .id('show_legend')
                .type('checkbox');
            if (_this.settings.showLegend)
                b.attr('checked', '');
        })
            .addText(' ' + i18n.getText('Facets', 'Chart', 'ShowLegendLabel')); }); });
    };
    ChartFacet.prototype.afterDialogOpened = function (dlg) {
        if (this.getContext().resultTable.columns.getItems().filter(function (col) { return dataUtils.isNumericType(col.type); }).length <= 0) {
            dlg.showAlert('The dataset should contain at least one numeric column to build a chart', 'error');
            dlg.getSubmitButtonElement().disabled = true;
        }
    };
    ChartFacet.prototype.submitSettingsDialog = function () {
        var result = _super.prototype.submitSettingsDialog.call(this);
        var chartTypeSelector = document.getElementById('chart_type_selector');
        var ct = parseInt(chartTypeSelector.value);
        var labelColumnSelector = document.getElementById('label_column_selector');
        var labelColumn = parseInt(labelColumnSelector.value);
        var dataColumnSelector = document.getElementById('data_column_selector');
        var dataColumn = parseInt(dataColumnSelector.value);
        var showLegendInput = document.getElementById('show_legend');
        var showLegend = showLegendInput.checked;
        if (result) {
            this.settings = {
                type: ct,
                labelColumn: labelColumn,
                dataColumn: dataColumn,
                showLegend: showLegend
            };
            if (this.canDisplay()) {
                this.refresh();
            }
        }
        return result;
    };
    ChartFacet.prototype.getSettings = function () {
        return this.settings;
    };
    ChartFacet.prototype.saveToData = function () {
        var data = _super.prototype.saveToData.call(this);
        if (this.settings) {
            data.chartType = this.settings.type;
            data.labelCol = this.settings.labelColumn;
            data.dataCol = this.settings.dataColumn;
            data.showLeg = this.settings.showLegend;
        }
        return data;
    };
    ChartFacet.prototype.loadFromData = function (data) {
        _super.prototype.loadFromData.call(this, data);
        if (data) {
            this.settings = {
                type: data.chartType,
                dataColumn: data.dataCol,
                labelColumn: data.labelCol,
                showLegend: data.showLeg
            };
        }
    };
    ChartFacet.prototype.refreshCore = function () {
        if (this.chart) {
            if (this.settings) {
                this.chart.updateSettings(this.settings);
            }
            this.chart.prepareChartData();
            this.chart.refresh();
        }
    };
    ChartFacet.prototype.onResize = function () {
        this.refresh();
    };
    return ChartFacet;
}(ResultFacet));
export { ChartFacet };
//# sourceMappingURL=chart_facet.js.map